// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3nT__","error":"Textarea_error__3vz4A","readonly":"Textarea_readonly__201OW","disabled":"Textarea_disabled__2G3Jh"};